module.exports = __webpack_public_path__ + "img/phone.5e505b41.png";